'use client'
import clsx from 'clsx'
import Link from 'next/link'

import { getRoute, } from '@/utils/utils'
import { Button } from '@/stories/atoms/Button/Button'
import { Icon } from '@/stories/atoms/Icon/Icon'
import { TabsProvider } from '@/stories/components/Tabs/TabsContext'
import { Tabs } from '@/stories/components/Tabs/Tabs'
import { Tab } from '@/stories/components/Tabs/Tab'
import { type LocalityType } from '@/stories/components/Form/LocalitySearch/LocalitySearch';
import { TabPanel } from '@/stories/components/Tabs/TabPanel'
import { SearchPanel } from './SearchPanel'
import { EstimatePanel } from './EstimatePanel'

import styles from './search-module.module.css'

export const SearchModule = ({
  locality,
  redirectBuyUrl,
  redirectRentUrl
}: {
  locality?: LocalityType,
  redirectBuyUrl?: string,
  redirectRentUrl?: string
}) => {

  const tabs = [
    ...(redirectBuyUrl ? [{
      label: 'Acheter',
      panel: <SearchPanel context='buy' locality={locality} redirectUrl={redirectBuyUrl}/>
    }] : []),
    ...(redirectRentUrl ? [{
      label: 'Louer',
      panel:  <SearchPanel context='rent' locality={locality} redirectUrl={redirectRentUrl}/>
    }] : []),
    ...((redirectBuyUrl || redirectRentUrl) ? [{
      label: 'Estimer',
      panel: <EstimatePanel estimLoc={redirectRentUrl ? true : false} estimBuy={redirectBuyUrl ? true : false}/>
    }] : []),
  ]

  return (
    <div className={styles.wrapper} id='search'>
      <TabsProvider>
        <Tabs>
          {tabs.map(({label}, i) => <Tab className={styles.tab} key={i} index={i} label={label} tabTd={`search-tab-${i}`} panelId={`search-panel-${i}`}/>)}
        </Tabs>
        {tabs.map((tab, i) => <TabPanel key={i} index={i} tabId={`search-tab-${i}`} panelId={`search-panel-${i}`} className={styles.panel}>{tab.panel}</TabPanel>)}
      </TabsProvider>
      <Button className={clsx(styles.button, 'hide-sub-md')} variant='primary' asChild><Link href={getRoute({key: 'discovery'})}>Confier nous votre recherche <Icon icon='bullseye-pointer'/></Link></Button>
    </div>
  )
};
